export default __webpack_public_path__ + "static/media/live.ea5c6418.gif";